import { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./PlaceholderStepsModal.module.css";
import { PlaceholderConfigInterface } from "../../Types";

type Props_PlaceholderStepsModal = {
    onClose: () => any;
    children: ReactNode;
    standAlone: boolean;
    isMobile: boolean;
    bundleConfig: PlaceholderConfigInterface;
    inspectorMode?: boolean;
    previewType: any;
    placement: "bundle" | "swatches";
};

const CloseIcon = ({ size = 15, color = "currentColor" }: { size?: number; color?: string }) => {
    return (
        <svg
            style={{
                minHeight: size,
                minWidth: size,
            }}
            stroke={color}
            fill={color}
            strokeWidth="10"
            viewBox="0 0 512 512"
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
        </svg>
    );
};
const PlaceholderStepsModal = ({
    onClose,
    children,
    bundleConfig,
    inspectorMode = false,
    previewType,
    placement = "bundle",
    standAlone = false,
}: Props_PlaceholderStepsModal) => {
    useEffect(() => {
        if (!standAlone) return;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [standAlone]);

    const wrapper: Element | DocumentFragment =
        (inspectorMode || previewType == 1
            ? document.getElementById(
                  placement === "swatches" ? "swatchesModalRightSectionId" : "rightSectionContainerId",
              )
            : null) || document.body;

    return ReactDOM.createPortal(
        <div
            className={styles.overlay}
            id="placeholderStepsModalOverlayId"
            style={{
                ...(inspectorMode || previewType == 1
                    ? {
                          position: "absolute",
                          height: "100%",
                          borderRadius: "8px",
                          alignItems: "flex-end",
                          zoom: "0.8",
                      }
                    : {}),
            }}
            onClick={onClose}
            data-form-id={bundleConfig?.form_id}
        >
            <span
                className={styles.closeBtnWrapper}
                style={{
                    ...(inspectorMode || previewType == 1
                        ? { position: "absolute", top: "10px" }
                        : {
                              position: "fixed",
                              top: "calc(env(safe-area-inset-top, 0px) + 20px)",
                              left: "50%",
                              transform: "translateX(-50%)",
                          }),
                }}
            >
                <button className={styles.closeBtn} onClick={onClose}>
                    <CloseIcon size={18} />
                </button>
            </span>

            <div
                className={styles.modal}
                style={{
                    background: bundleConfig?.bundles_design?.bundle_widget_bg || "white",
                    ...(inspectorMode || previewType == 1
                        ? {
                              position: "relative",
                              maxWidth: "100%",

                              //   marginBottom: "10px",
                          }
                        : {}),
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.mainContainer}>{children}</div>
            </div>
        </div>,
        wrapper,
    );
};

export default PlaceholderStepsModal;
